import { render, staticRenderFns } from "./singleTotalRingChart.vue?vue&type=template&id=6b3fc20d&scoped=true&"
import script from "./singleTotalRingChart.vue?vue&type=script&lang=js&"
export * from "./singleTotalRingChart.vue?vue&type=script&lang=js&"
import style0 from "./singleTotalRingChart.vue?vue&type=style&index=0&id=6b3fc20d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fc20d",
  null
  
)

export default component.exports